// extracted by mini-css-extract-plugin
module.exports = {"toast":"Toast_toast__21c9f","primary":"Toast_primary__1BN2F","warning":"Toast_warning__2G-mz","close":"Toast_close__3rhKg"};